import PrismaSection from './PrismaSection';
export default PrismaSection;
